import React, { useState, useEffect } from "react";
import axios from "axios";
import { BaseUrl } from "../../Container/BaseUrl/BaseUrl";
import { connect } from "react-redux";
import { setSelectedMenu } from "../../Redux/Actions/actions";
import moment from "moment";
import moment2 from "moment-timezone";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { IoIosArrowBack } from "react-icons/io";
import Nodata from "../../Assets/images/svg/Data-unavailable.svg";
import {
  ButtonGroup,
  Drawer,
  Button,
  Pagination,
  Stack,
  Typography,
  Box,
} from "@mui/material";
// component imported
import { DownloadSimple, FunnelSimple } from "@phosphor-icons/react";
import { Hourglass } from "react-loader-spinner";
import { TiWarningOutline } from "react-icons/ti";
import {
  StyledPaper,
  StyledTableContainer,
  StyledTable,
  StyledTableHead,
  StyledTableBody,
  StyledTableRow,
  StyledTableCell,
  StyledTableCell2,
} from "../../CustomComponent/TableCompoent";

const mapStateToProps = (state) => {
  return {
    selectedMenu: state.contactListData.selectedMenu,
  };
};
const Agentreport = (props) => {
  const [showfilter, setshowfilter] = useState(false);
  var someDate = new Date();
  var date = someDate.setDate(someDate.getDate());
  var defaultValue = new Date(date).toISOString().split("T")[0];
  const [agentdata, setAgentdata] = useState([]);
  const [fromdate, setFromdate] = useState(defaultValue);
  const [todate, setTodate] = useState(defaultValue);
  const [pagination, setPagination] = useState(0);
  const [page, setPage] = useState(1);
  const [show, setShow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingAgentreports, setloadingAgentreports] = useState(false);
  const [fromDateError, setFromDateError] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const basedOnRole = JSON.parse(localStorage.getItem("tokenAgent"));
  useEffect(() => {
    agentReportData();
  }, [page]);

  const agentReportData = async () => {
    setLoading(true);
    const Credentials = { fromdate, todate, page, defaultValue };
    await axios
      .post(
        BaseUrl + "/dashboard/tasklist",
        {
          from_date: fromdate ? fromdate : defaultValue,
          to_date: todate ? todate : defaultValue,
          offset: page == 1 ? 0 : (page - 1) * 10,
          limit: 10,
          agent_id: basedOnRole.id,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        setLoading(true);
        if (res.data.success == true) {
          setLoading(false);
          setAgentdata(res.data.Data);
          setPagination(res.data.count);
        } else {
          setLoading(false);
          setAgentdata([]);
          setPagination(0);
        }
      })
      .catch((error) => {
        setAgentdata([]);
        setLoading(false);
        setShow(true);
      });
  };

  const agentReportData1 = async (ToPage1) => {
    setLoading(true);
    const Credentials = { fromdate, todate, page, defaultValue };
    await axios
      .post(
        BaseUrl + "/dashboard/tasklist",
        {
          from_date: fromdate ? fromdate : defaultValue,
          to_date: todate ? todate : defaultValue,
          offset: ToPage1,
          limit: 10,
          agent_id: basedOnRole.id,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        setLoading(true);
        if (res.data.success == true) {
          setLoading(false);
          setAgentdata(res.data.Data);
          setPagination(res.data.count);
        } else {
          setLoading(false);
          setAgentdata([]);
          setPagination(0);
        }
      })
      .catch((error) => {
        setAgentdata([]);
        setLoading(false);
        setShow(true);
      });
  };

  const DownloadAgentReport = () => {
    setIsLoading(true);
    axios
      .post(
        BaseUrl + "/dashboard/tasklistexcel",
        {
          from_date: fromdate,
          to_date: todate,
          agent_id: basedOnRole.id,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        },
        {}
      )
      .then((res) => {
        console.log("resss", res);
        setIsLoading(true);
        if (res.data.status == true) {
          setIsLoading(false);
          let file =
            localStorage.getItem("frontendBaseURL") +
            "files" +
            res.data.message;
          window.open(file);
        } else {
          toast.warn("No Data Found", {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }
      })
      .catch((error) => {});
  };

  const handleChange = (event, value) => {
    setPage(value);
  };

  return (
    // AGENT REPORTS start
    <StyledPaper>
      <div className="card Report-card w-100 border-0">
        {/* card-header  */}
        <div
          className="card-header border-0 d-flex align-items-center justify-content-between px-2"
          sx={{ fontWeight: 600, color: "#1473e6" }}
        >
          <div
            className="fw-bold fs-16"
            style={{
              textShadow: "1px 0px 0px #c2c2c27d",
              color: "#0b3363",
            }}
          >
            Agent Reports
          </div>
          <div>
            <ButtonGroup
              variant="contained"
              aria-label="button group"
              disableElevation
              size="small"
              sx={{
                textTransform: "capitalize",
              }}
            >
              {/* Back btn  */}

              <Button
                sx={{
                  textTransform: "capitalize",
                }}
                onClick={() => {
                  props.setSelectedMenu("ReportMenu");
                }}
              >
                <IoIosArrowBack className="me-2" />
                Back
              </Button>

              {/* Download btn  */}
              <Button
                sx={{
                  textTransform: "capitalize",
                }}
                disabled={isLoading}
                onClick={DownloadAgentReport}
              >
                <DownloadSimple className="me-2" />
                {isLoading ? "Downloading..." : "Download Report"}
              </Button>
              {/* Filter btn  */}
              <Button
                sx={{
                  textTransform: "capitalize",
                }}
                onClick={() => {
                  setshowfilter(true);
                }}
              >
                <FunnelSimple className="me-2" />
                Filter
              </Button>
            </ButtonGroup>
          </div>
        </div>
        {/* card-body */}
        <div
          className="card-body p-1 vh-71 box-inset"
          sx={{
            justifyContent: "center",
            display: "flex",
            height: "calc(100% - 40px)",
            display: "flex",
            flexDirection: "column",
            gap: "10",
          }}
        >
          <Box>
            <StyledTableContainer sx={{ height: "26rem !important" }}>
              <StyledTable stickyHeader aria-label="sticky table" size="small">
                <StyledTableHead>
                  <StyledTableRow>
                    {[
                      "Agent Name",
                      "Break Time",
                      "Active Time",
                      "Outbound",
                      "Inbound",
                      "Date",
                    ].map((headers) => (
                      <StyledTableCell style={{ minWidth: "150px" }}>
                        {headers}
                      </StyledTableCell>
                    ))}
                  </StyledTableRow>
                </StyledTableHead>
                <StyledTableBody>
                  {loading ? (
                    <Stack
                      sx={{ position: "absolute", top: "50%", left: "50%" }}
                    >
                      <Hourglass
                        visible={true}
                        height="30"
                        width="30"
                        ariaLabel="hourglass-loading"
                        wrapperStyle={{}}
                        wrapperClass=""
                        colors={["#2268a0", "#72a1ed"]}
                      />
                    </Stack>
                  ) : agentdata.length > 0 ? (
                    agentdata.map((rowData, rowIndex) => {
                      var seconds = rowData.total_break_time;
                      var duration = moment.duration(seconds, "seconds");
                      var total_break_time = moment
                        .utc(duration.asMilliseconds())
                        .format("HH:mm:ss");

                      var seconds_active = rowData.total_active_time;
                      var duration_active = moment.duration(
                        seconds_active,
                        "seconds"
                      );
                      var total_active_time = moment
                        .utc(duration_active.asMilliseconds())
                        .format("HH:mm:ss");

                      return (
                        <StyledTableRow hover role="checkbox" tabIndex={-1}>
                          <StyledTableCell2>
                            {rowData.agent_id == null ||
                            rowData.agent_id == undefined ||
                            rowData.agent_id == ""
                              ? "--"
                              : rowData.agent_id.username}
                          </StyledTableCell2>

                          <StyledTableCell2>
                            {total_break_time}
                          </StyledTableCell2>

                          <StyledTableCell2>
                            {total_active_time}
                          </StyledTableCell2>

                          <StyledTableCell2>
                            {rowData.total_completed_outbound}
                          </StyledTableCell2>

                          <StyledTableCell2>
                            {rowData.total_completed_inbound}
                          </StyledTableCell2>

                          <StyledTableCell2>
                            {moment2(rowData.created_at).format("L")}
                          </StyledTableCell2>
                        </StyledTableRow>
                      );
                    })
                  ) : (
                    // Data unavailable start
                    <Stack
                      sx={{
                        position: "absolute",
                        width: "100%",
                        height: "calc(100vh - 14rem)",
                      }}
                      justifyContent="center"
                      alignContent="center"
                    >
                      <Stack
                        className="text-muted"
                        direction="column"
                        justifyContent="center"
                        alignContent="center"
                      >
                        <span className="mx-auto">
                          <img
                            src={Nodata}
                            alt="pic"
                            style={{ width: "11rem", userSelect: "none" }}
                          />
                        </span>
                        <span className="mx-auto">
                          <h6
                            className="text-muted mt-3"
                            style={{ fontSize: "13px" }}
                          >
                            Data unavailable
                          </h6>
                        </span>
                      </Stack>
                    </Stack>
                    // Data unavailable end
                  )}
                </StyledTableBody>
              </StyledTable>
            </StyledTableContainer>
          </Box>
        </div>
        {/* card-footer */}
        <div className="card-footer border-0">
          <Box>
            <Stack
              sx={{ width: "100%", height: "100%" }}
              direction={"row"}
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              {/* Pagination content  */}
              <Typography variant="caption" sx={{ fontSize: "12px" }}>
                Showing{" "}
                {Math.min(
                  (page - 1) * 10 + 1,
                  isNaN(pagination) ? 0 : pagination
                )}{" "}
                to {Math.min(page * 10, isNaN(pagination) ? 0 : pagination)} of{" "}
                {isNaN(pagination) ? 0 : pagination} entries
              </Typography>
              {/* Pagination  */}
              <Pagination
                count={Math.ceil(pagination / 10)}
                page={page}
                variant="outlined"
                shape="rounded"
                color="primary"
                size="small"
                style={{ float: "right" }}
                onChange={handleChange}
              />
            </Stack>
          </Box>
        </div>
      </div>

      {/* Filters Drawer Start  */}
      <Drawer
        anchor="right"
        open={showfilter}
        onClose={() => {
          setshowfilter(false);
        }}
      >
        <Box style={{ width: "20rem" }}>
          {/* Drawer head start */}
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            className="p-3 shadowDrawer"
          >
            <Typography variant="h3" gutterBottom className="drawer-title">
              Filters
            </Typography>
          </Stack>
          {/* Drawer head end */}
          {/* Drawer Content start */}
          <Stack
            className="p-3"
            style={{ height: "calc(100vh - 7rem)", overflowY: "scroll" }}
          >
            <form className="fs-13">
              <div className="custom_div">
                <div className="mb-3 d-flex flex-column text-start">
                  <label htmlFor="fromdate" className="form-label">
                    From
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    id=""
                    aria-describedby="date"
                    value={fromdate}
                    onChange={(e) => setFromdate(e.target.value)}
                    max={defaultValue}
                  />
                </div>
                <div className="mb-3 d-flex flex-column text-start">
                  <label htmlFor="todate" className="form-label">
                    To
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    id=""
                    aria-describedby="date"
                    onChange={(e) => setTodate(e.target.value)}
                    value={todate}
                    max={defaultValue}
                  />
                  {fromDateError ? (
                    <span
                      className="text-danger fw-500"
                      style={{ fontSize: "10px" }}
                    >
                      To Date Should Less Than From Date
                    </span>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </form>
          </Stack>
          {/* Drawer Content end */}
          {/* Drawer footer start */}
          <Stack
            className="p-2"
            sx={{
              position: "absolute",
              bottom: "0",
              background: "#f9f9f9",
              width: "100%",
              boxShadow:
                "rgba(14, 63, 126, 0.04) 0px 0px 0px 1px, rgba(42, 51, 69, 0.04) 0px 1px 1px -0.5px, rgba(42, 51, 70, 0.04) 0px 3px 3px -1.5px, rgba(42, 51, 70, 0.04) 0px 6px 6px -3px, rgba(14, 63, 126, 0.04) 0px 12px 12px -6px, rgba(14, 63, 126, 0.04) 0px 24px 24px -12px",
            }}
            direction="row"
            justifyContent="space-between"
            alignContent="center"
          >
            <Button
              variant="contained"
              className="me-2 w-100"
              sx={{
                textShadow: "0 1px 0 rgba(0, 0, 0, .4)",
                textTransform: "Capitalize",
              }}
              color="error"
              disableElevation
              onClick={() => {
                setshowfilter(false);
              }}
            >
              Close
            </Button>
            <Button
              className="w-100"
              variant="contained"
              disableElevation
              sx={{
                textShadow: "0 1px 0 rgba(0, 0, 0, .4)",
                textTransform: "Capitalize",
              }}
              id="session_filter_Submit"
              onClick={() => {
                if (moment(fromdate).isAfter(todate)) {
                  setFromDateError(true);
                } else {
                  setFromDateError(false);
                  agentReportData1(0);
                  setPage(1);
                  setshowfilter(false);
                }
              }}
            >
              Submit
            </Button>
          </Stack>
          {/* Drawer footer end */}
        </Box>
      </Drawer>
      {/* Filters Drawer End  */}
    </StyledPaper>
    // AGENT REPORTS end
  );
};

export default connect(mapStateToProps, {
  setSelectedMenu,
})(Agentreport);
